import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const cases = [
  {
    tag: "E-COMMERCE / DTC",
    title: "Kubex",
    desc: "Rebuilt the entire paid social stack and scaled from $80K to $1.2M monthly ad spend at a 4.1× ROAS.",
    metric: "+140%",
    metricLabel: "ROAS",
    img: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?auto=format&fit=crop&w=1400&q=80",
  },
  {
    tag: "SAAS / B2B",
    title: "Trilogy",
    desc: "A brand-led SEO play took Trilogy from page 3 to ranking #1 for 42 of its top revenue keywords in 6 months.",
    metric: "2.4M",
    metricLabel: "ORGANIC / MO",
    img: "https://images.unsplash.com/photo-1498262257252-c282316270bc?auto=format&fit=crop&w=1400&q=80",
  },
];

export default function CaseStudies() {
  return (
    <section
      id="work"
      data-testid="cases-section"
      className="py-24 md:py-32 lg:py-40 bg-[#09090b] text-white"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="md:col-span-4">
            <div className="text-xs font-mono uppercase tracking-widest text-zinc-500 mb-4">
              [ 03 — SELECTED WORK ]
            </div>
          </div>
          <div className="md:col-span-8">
            <h2
              data-testid="cases-title"
              className="font-display font-black uppercase tracking-tighter leading-none text-5xl md:text-6xl lg:text-7xl"
            >
              Receipts, <br />
              not <span className="text-[#002FA7]">rhetoric.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          {cases.map((c, i) => (
            <motion.a
              key={c.title}
              href="#contact"
              data-testid={`case-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="group relative block overflow-hidden"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/25 transition-colors duration-500" />
                <div className="absolute inset-0 flex flex-col justify-between p-6 md:p-10">
                  <div className="flex items-start justify-between">
                    <span className="font-mono text-[10px] uppercase tracking-widest text-white/80">
                      {c.tag}
                    </span>
                    <ArrowUpRight className="w-6 h-6 text-white transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1" />
                  </div>
                  <div>
                    <div className="font-display font-black text-white text-7xl md:text-8xl lg:text-9xl leading-none tracking-tighter">
                      {c.metric}
                    </div>
                    <div className="text-xs font-mono uppercase tracking-widest text-white/80 mt-2">
                      {c.metricLabel}
                    </div>
                  </div>
                </div>
              </div>
              <div className="pt-6 border-t border-zinc-800 mt-6 grid grid-cols-12 gap-4">
                <div className="col-span-12 md:col-span-4">
                  <h3 className="font-display font-bold uppercase text-2xl">
                    {c.title}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-8">
                  <p className="text-sm md:text-base text-zinc-400 leading-relaxed">
                    {c.desc}
                  </p>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
